import { createTheme } from '@mui/material';
import typography from './typography';
import { lighten, darken } from '@mui/system';
import MuiDataGrid from './overrides/MuiDataGrid';
import { alpha } from '@mui/material/styles';

const PRIMARY_MAIN = '#401AFF';

const appTheme = createTheme({
    typography,
    palette: {
        primary: {
            // main: '#1565d8',
            main: PRIMARY_MAIN,
            light: lighten(PRIMARY_MAIN, 0.85),  // 20% lighter shade
            dark: darken(PRIMARY_MAIN, 0.2),    // 20% darker shade
            contrastText: '#ffffff',             // white text for buttons/appbars
        },
        background: {
            default: '#fff',
            paper: '#fff',
        },
        // This sets the "hover" and "selected" defaults for all components
        action: {
            hover: alpha(PRIMARY_MAIN, 0.3),       // primary.light with transparency
            // selected: lighten(PRIMARY_MAIN, 0.85),    // primary.light slightly more opaque
            selectedOpacity: 0.3,     // affects some components like ListItemButton
        },
    },
    components: {
        MuiDataGrid,
    },
});

export default appTheme;